<template>
  <div>
    <div class="page-header header-filter header-tiny bg-tri-1">
      <b-container>
        <b-row align-h="center">
        <h1>Rides</h1>
        </b-row>
      </b-container>
    </div>
    <div>
      <b-container>
        <b-row>
          <b-col>
            <h1>Rides</h1>
          </b-col>
        </b-row>
        <!-- <b-row>
          <b-col>
            <input type="text" v-model="title" placeholder="Title" />
            <input type="text" v-model="worldId" placeholder="World id" />
            <input type="text" v-model="startMarkerId" placeholder="Start marker id" />
            <input type="text" v-model="endMarkerId" placeholder="End marker id" />
          </b-col>
          <b-col>
            <b-button v-on:click="createSegment({ title, worldId, startMarkerId, endMarkerId })">
              Create Segment
            </b-button>
          </b-col>
        </b-row> -->
        <b-row v-for="item in rides" :key="item.id">
          <b-col>
            <h3>{{ item.title }}</h3>
            <ul>
              <li v-for="(value,prop) in item" :key="prop">{{prop}}: {{value}}</li>
            </ul>
            <hr />
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapState, mapActions } = createNamespacedHelpers("admin/rides");

export default {
  name: "Rides",
  async created() {
    this.loadRides();
  },
  // data() {
  //   return {
  //     title: "",
  //     worldId: "",
  //     startMarkerId: "",
  //     endMarkerId: ""
  //   };
  // },
  computed: {
    ...mapState(["rides"])
  },
  methods: {
    ...mapActions(["createRide", "loadRides"])
  }
};
</script>

<style>
</style>